import {
  Container,
  createStyles,
  Grid,
  makeStyles,
  Theme,
} from '@material-ui/core';
import React, { FC, Fragment, useEffect, useState } from 'react';
import {
  GalleryImage,
  HasEvent,
  LocationData,
  LocationDeviceAndGal,
  Devices,
} from '../../api/infomodul/models';
import InfoModulHeader from '../../components/infoModul/Header';
import DeviceList from '../../components/infoModul/DeviceList';
import GalleryList from '../../components/infoModul/gallery/GalleryList';
import PendingDialog from '../../components/dialogs/PendingDialog';
import FrontView from '../../components/infoModul/gallery/FrontView';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // con: {
    //     margin: theme.spacing(1),
    // },
    formControl: {
      //   margin: theme.spacing(1),
      minWidth: 120,
    },
    buts: {
      // margin: theme.spacing(1),
      // height: '100%'
    },
    center: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    tabs: {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    fullHeight: {
      height: '100%',
    },
    maxParent: {
      maxWidth: '100%',
      maxHeight: '10rem',
    },
  })
);

type Props = {};

const InfoModul: FC<Props> = () => {
  const classes = useStyles();
  const [selectedLocation, setSelectedLocation] = useState<LocationData>();
  const [selectedDevices, setSelectedDevices] = useState<number[]>([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [isPending, setIsPending] = useState(false);
  const [locationData, setLocationData] = useState<LocationDeviceAndGal>({
    galleries: [],
    devices: [],
  });
  const [galleryData, setGalleryData] = useState<GalleryImage[]>([]);
  const [eventData, setEventData] = useState<HasEvent[]>([]);
  const [devData, setDevData] = useState<Devices[]>([]);
  const [masterID, setMasterID] = useState<number>();
  const [selectedDeviceIds, setSelectedDeviceIds] = useState<number[]>([]);

  const [deviceBoxDisabled, setDeviceBoxDisabled] = useState(false);
  const [updateOnDeviceBoxChange, setUpdateOnDeviceBoxChange] = useState(true);
  const [runGetGalleryImages, setRunGetGalleryImages] = useState(false);
  const [runGetDevices, setRunGetDevices] = useState(false);
  const [runGetEvents, setRunGetEvents] = useState(false);
  const [runUpdateLocationData, setRunUpdateLocationData] = useState(false);
  
  //Call for getting devices
  useEffect(() => {
    if (devData.length === 0) {
      setRunGetDevices(true);
    }
  }, [setRunGetDevices, devData]);

  //Call for getting event data
  useEffect(() => {
    if (eventData.length === 0) {
      setRunGetEvents(true);
    }
  }, [eventData.length]);

  return (
    <Fragment>
      <InfoModulHeader
        isPending={isPending}
        setIsPending={setIsPending}
        selectedLocation={selectedLocation}
        setSelectedLocation={setSelectedLocation}
        setLocationData={setLocationData}
        setDeviceData={setDevData}
        runGetDevices={runGetDevices}
        setRunGetDevices={setRunGetDevices}
        setMasterId={setMasterID}
        updateLocationData={runUpdateLocationData}
      />
      {locationData.galleries.length === 0 &&
      locationData.devices.length === 0 ? (
        <Grid container>
          <Grid item xs={12}>
            <div>Vælg en plads, og tryk hent</div>
          </Grid>
        </Grid>
      ) : (
        <Container maxWidth={'xl'}>
          <Grid container spacing={2} className={classes.formControl}>
            <Grid item xs={12} md={3} lg={2}>
              <DeviceList
                deviceData={devData}
                selectedDevices={selectedDevices}
                setSelectedDevices={setSelectedDevices}
                deviceBoxDisabled={deviceBoxDisabled}
                masterID={masterID!}
                selectedDevicesIds={selectedDeviceIds}
                setSelectedDevicesIds={setSelectedDeviceIds}
              />
            </Grid>
            <Grid item xs={12} md={9} lg={10}>
              <Grid container spacing={1}>
                <GalleryList
                  setSelectedTab={setSelectedTab}
                  locationData={locationData}
                  setGalleryData={setGalleryData}
                  setEventData={setEventData}
                  runGetGalleryImages={runGetGalleryImages}
                  setRunGetGalleryImages={setRunGetGalleryImages}
                  runGetEvents={runGetEvents}
                  setRunGetEvents={setRunGetEvents}
                  masterId={masterID!}
                  updateLocationData={setRunUpdateLocationData}
                />
                <Grid item xs={12} md={12}>
                  <FrontView
                    selectedDevices={selectedDevices}
                    selectedDevicesIds={selectedDeviceIds}
                    locationData={locationData}
                    galleryData={galleryData}
                    deviceData={devData}
                    eventData={eventData}
                    selectedTab={selectedTab}
                    selectedLocation={selectedLocation}
                    setDeviceBoxDisabled={setDeviceBoxDisabled}
                    setUpdateOnDeviceBoxChange={setUpdateOnDeviceBoxChange}
                    updateOnDeviceBoxChange={updateOnDeviceBoxChange}
                    setRunGetGalleryImages={setRunGetGalleryImages}
                    setRunGetEventInfo={setRunGetEvents}
                    setSelectedDeviceIds={setSelectedDeviceIds}
                    setSelectedDevices={setSelectedDevices}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
      <PendingDialog open={isPending} title={'Loading'} />
    </Fragment>
  );
};

export default InfoModul;
